document.addEventListener( 'DOMContentLoaded', function () {
  function eachElem(selector) {
    if (document.querySelector(selector)) {
      let allElems = document.querySelectorAll(selector);
      let allElemsArr = Array.prototype.slice.call(allElems);
      return allElemsArr;
    }
  }
  function get_cookie(name) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let [key,value] = el.split('=');
        cookie[key.trim()] = value;
    });
    return cookie[name];
  }

  function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }
  
  function removeElement(element) {
    element.remove();
  }

  if (document.querySelector(".scroll-to-element")) {
    var allLink = document.querySelectorAll('.scroll-to-element');
	var allLinkArr = Array.prototype.slice.call(allLink);
	allLinkArr.forEach(function(link, index){
	  link.addEventListener('click',function(e){
        e.preventDefault();
        var target = link.getAttribute('href');
        var elementPos = offset(document.querySelector(target)).top - 200;
        window.scrollTo({top: elementPos, behavior: 'smooth'});
      }); 
	});
  }

  if (document.querySelector('.menu-drawer__header-close')) {
    document.querySelector('.menu-drawer__header-close').addEventListener('click',function(){
      if (document.querySelector('#Details-menu-drawer-container').classList.contains('menu-opening')) {
        document.querySelector('#Details-menu-drawer-container').classList.remove('menu-opening');
      }
      if (document.querySelector('#Details-menu-drawer-container').hasAttribute('open')) {
        setTimeout(function(){
          document.querySelector('#Details-menu-drawer-container').removeAttribute('open');
        },400);
      }
      if (document.querySelector('body').classList.contains('overflow-hidden-tablet')) {
        document.querySelector('body').classList.remove('overflow-hidden-tablet');
      }
      document.querySelector('#Details-menu-drawer-container > summary').setAttribute('aria-expanded', false);
    });
  }

  if (document.querySelector('.fixed-header')) {
    console.log('fixed-header');
    function fixedHeader(){
      var header = document.querySelector('.fixed-header');
      var headerHeight = header.offsetHeight;

      var announcementBarGroup = document.querySelector('.shopify-section--announcement-bar-custom');
      //headerHeight += announcementBarGroup.offsetHeight;

      var totalBarsHeight = 0;
      var totalFixedBarsHeight = 0;
      var allBars = document.querySelectorAll('.announcement-bar');
      
      var allBarsArr = Array.prototype.slice.call(allBars);
      allBarsArr.forEach(function(el, index){
        totalBarsHeight += el.offsetHeight;
        if (el.classList.contains('announcement-bar--fixed')) {
          totalFixedBarsHeight += el.offsetHeight;
        }
      });

      var windowPos = window.pageYOffset || document.documentElement.scrollTop;

      header.style.position = 'fixed';
      header.style.width = '100vw';
      document.querySelector('main').style.marginTop = headerHeight+'px';
      var headerTop = totalFixedBarsHeight + (totalBarsHeight - totalFixedBarsHeight - windowPos);
      if (totalBarsHeight - totalFixedBarsHeight - windowPos < 0) {
        headerTop = totalFixedBarsHeight;
      }
      header.style.top = headerTop + 'px';
      //document.querySelector('#menu-drawer.menu-drawer').style.paddingTop = Number(headerTop + 7) + 'px';
    }
    fixedHeader();
    window.addEventListener('scroll', function(){
      fixedHeader();
    });
  }

  if(document.querySelector('.header__icon--help')){
    document.querySelector('.header__icon--help').addEventListener('click', function(e) {
      if (window.innerWidth < 500) {
        document.querySelector('.header__icon--help').classList.toggle('open');
      }
    });
  }

  // Sticky sidebar filter
  if (document.querySelector('body .ais-page .ais-block')) {
    function stickyFilter(scrollToTop) {
      if (window.innerWidth >= 800) {
        var rect = document.querySelector('body .ais-page .ais-block').getBoundingClientRect();
        var parentHeight = document.querySelector('body .ais-page').offsetHeight - 100;
        var filterWidth = document.querySelector('body .ais-page .ais-facets').offsetWidth;
        var filterHeight = document.querySelector('body .ais-page .ais-facets-inner').offsetHeight;
        var announcementBarHeight = 0;
        var allBars = document.querySelectorAll('.announcement-bar--fixed');
        var allBarsArr = Array.prototype.slice.call(allBars);
        allBarsArr.forEach(function(bar, index){
            announcementBarHeight += bar.offsetHeight;
        });
        var headerHeight = document.querySelector('.fixed-header').offsetHeight;
        var filterTopPos = announcementBarHeight + headerHeight;
        if (scrollToTop) {
          var headerHeight = document.querySelector('.header-wrapper').offsetHeight;
          filterTopPos = announcementBarHeight + headerHeight;
        }
        if (parentHeight > filterHeight) {
          if (rect.top < filterTopPos) {
            if (!document.querySelector('.ais-facets-inner').classList.contains('fixed')) {
              document.querySelector('.ais-facets-inner').classList.add('fixed');
              document.querySelector('.ais-facets-inner').style.width = filterWidth + 'px'
            }
            document.querySelector('.ais-facets-inner').style.top = filterTopPos + 'px';
            if (rect.top + parentHeight - filterHeight - filterTopPos <= 0) {
              if (document.querySelector('.ais-facets-inner').classList.contains('fixed')) {
                document.querySelector('.ais-facets-inner').classList.remove('fixed');
              }
              document.querySelector('.ais-facets').style.marginTop = parseInt(parentHeight - filterHeight) + 'px';
            } else {
              document.querySelector('.ais-facets').style.marginTop = '10px';
            }
          } else {
            if (document.querySelector('.ais-facets-inner').classList.contains('fixed')) {
              document.querySelector('.ais-facets-inner').classList.remove('fixed');
              document.querySelector('.ais-facets-inner').removeAttribute('style');
            }
          }
        }
      } else {
        document.querySelector('.ais-facets').style.marginTop = '10px';
      }
    }
    
    var scrollToTop = false;
    stickyFilter(scrollToTop);
    var lastScrollTop = 0;

    window.addEventListener('click', function(e){
      if (e.target.classList.contains('ais-Pagination-link') && window.innerWidth >= 800){
        document.querySelector('.ais-facets').style.marginTop = '10px';
      }
    });
    
    window.addEventListener('scroll', function(){
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop){
        scrollToTop = false;
      } else {
        scrollToTop = true;
      }
      lastScrollTop = st <= 0 ? 0 : st;
      stickyFilter(scrollToTop);
    });
  }

  function stickyBar(){
    if (document.querySelectorAll('.announcement-bar--fixed').length > 0) {
      var fixed_bars_total_height = 0;
      var allFixedBars = document.querySelectorAll('.announcement-bar--fixed');
      var allFixedBarsArr = Array.prototype.slice.call(allFixedBars);
      allFixedBarsArr.forEach(function(bar, index){
        var current_bar_height = bar.offsetHeight;
        bar.style.top = fixed_bars_total_height + 'px';
        fixed_bars_total_height += current_bar_height;
        bar.style.position = 'fixed';
      });
      if (document.querySelector('.shopify-section--announcement-bar-custom')) {
        document.querySelector('.shopify-section--announcement-bar-custom').style.paddingTop = fixed_bars_total_height + 'px';
        document.querySelector('sticky-header').style.top = fixed_bars_total_height + 'px';
      }
    }
  }
  stickyBar();
  window.addEventListener('resize',function(){
    stickyBar();
  });

  if (document.querySelector('.product__info-container .shopify_subscriptions_app_container')) {
    function hideChildList(input_elem) { 
      if (input_elem.checked) {
        if (!input_elem.closest('.shopify_subscriptions_app_block_label').classList.contains('active')) {
          if (document.querySelector('.shopify_subscriptions_app_block_label.active')) {
            document.querySelector('.shopify_subscriptions_app_block_label.active').classList.remove('active');
          }
          input_elem.closest('.shopify_subscriptions_app_block_label').classList.add('active');
        }
      }
    }
    eachElem('.product__info-container .shopify_subscriptions_app_block input').forEach(function(input_elem, index){
      let label_elem = input_elem.closest('label');
      let label_elem_content = label_elem.innerHTML;
      let label_text = label_elem_content.replace(/(<([^>]+)>)/gi, "").replace(/(\r\n|\n|\r)/gm, "").trimStart().trimEnd();
      let childs = label_elem.childNodes;
      childs.forEach(c => c.nodeType === Node.TEXT_NODE && c.remove());
      let checkmark_elem = document.createElement('span');
      checkmark_elem.classList.add('checkmark');
      let text_elem = document.createElement('span');
      text_elem.innerHTML = label_text;
      text_elem.classList.add('checkmark-text');
      input_elem.after(checkmark_elem);
      label_elem.append(text_elem);

      hideChildList(input_elem);
      input_elem.addEventListener('change',function(e){
        hideChildList(input_elem);
      });
    });
  }

  /* announcement dynamic START */
  function dynamic_content_by_user_location(user_location) {
    if (user_location) {
      if (document.querySelector('.announcement-dynamic-text__item')) {
        eachElem('.announcement-dynamic-text__item').forEach(function(dynamic_elem, index){
          var user_region = dynamic_elem.getAttribute('data-region');
          var region_text = dynamic_elem.innerHTML;
          if (user_location.region == user_region) {
            document.querySelector('.announcement-bar--free-shipping').innerHTML = region_text;
          }
        });
      }
      if (document.querySelector('.custom-grid-sec__block-dynamic-content')) {
        if (user_location.country == 'US') {
          eachElem('.custom-grid-sec__block-dynamic-content').forEach(function(dynamic_elem, index){
            var user_region = dynamic_elem.getAttribute('data-region');
            var region_content = dynamic_elem.innerHTML;
            if (user_location.region == user_region) {
              dynamic_elem.closest('.custom-grid-sec__grid-item').innerHTML = region_content;
            }
          });
        } else {
          if (document.querySelector('.custom-grid-sec__block-dynamic-content--not-usa')) {
            let not_USA_content = document.querySelector('.custom-grid-sec__block-dynamic-content--not-usa').innerHTML;
            document.querySelector('.custom-grid-sec__block-dynamic-content--not-usa').closest('.custom-grid-sec__grid-item').innerHTML = not_USA_content;
          }
        }
      }
      if (document.querySelector('.announcement-bar--free-shipping')) {
        if (user_location.country != 'US') {
          document.querySelector('.announcement-bar--free-shipping').style.display = "none";
          if (document.querySelector('.shopify-section--announcement-bar-custom')) {
            let announcement_bar_lines_counter = document.querySelectorAll('.announcement-bar--fixed:not(.announcement-bar--free-shipping)').length;
            let bar_lines_height = 0;
            eachElem('.announcement-bar--fixed:not(.announcement-bar--free-shipping)').forEach(function(bar_line, index){
              bar_line.style.top = bar_lines_height + 'px';
              bar_lines_height += bar_line.offsetHeight;
            });
            document.querySelector('.shopify-section--announcement-bar-custom').style.paddingTop = bar_lines_height+'px';
            if (document.querySelector('.fixed-header')) {
              document.querySelector('.fixed-header').style.top = bar_lines_height+'px';
            }
          }
        }
      }
    }
  }

  function show_testimonials_by_user_location(user_location) {
    if (document.querySelector('.section--testimonials-static')) {
      var review_blocks = document.querySelectorAll('.section--testimonials-static .testimonials-sec__review-block[data-region="'+user_location.region+'"]');
      if (review_blocks.length >= 2) {
        const indexes = Array.from({ length: review_blocks.length }, (_, i) => i);
        const shuffled_indexes = indexes.sort(() => Math.random() - 0.5);
        const random_indexes = shuffled_indexes.slice(0, 2);
        console.log(random_indexes);
        random_indexes.forEach(index => {
          review_blocks[index].classList.add('active');
        });
      } else {
        if (review_blocks.length == 1) {
          document.querySelector('.section--testimonials-static .testimonials-sec__review-block[data-region="'+user_location.region+'"]').classList.add('active');
        }
      }
    }
  }

  if (
    document.querySelector('.announcement-dynamic-text__item') ||
    document.querySelector('.custom-grid-sec__block-dynamic-content') ||
    document.querySelector('.announcement-bar--free-shipping') ||
    document.querySelector('.section--testimonials-static')
  ) {
    if (get_cookie("api_location_region")) {
      let user_location = {
        region: get_cookie("api_location_region"),
        country: get_cookie("api_location_country")
      }
      dynamic_content_by_user_location(user_location);
      show_testimonials_by_user_location(user_location);
      console.log(user_location);
    } else {
      async function getRegion() {
        let user_location;
        try {
          const response = await fetch('https://ipinfo.io/json');
          user_location = await response.json();
        } catch (error) {
          if (error instanceof SyntaxError) {
            console.log('There was a SyntaxError', error);
          } else {
            console.log('There was an error', error);
          }
        }
        if (user_location) {
          let end_date = new Date(Date.now() + 2628e6);
          end_date = end_date.toUTCString();
          document.cookie = "api_location_region="+user_location.region+"; expires="+end_date;
          document.cookie = "api_location_country="+user_location.country+"; expires="+end_date;
          dynamic_content_by_user_location(user_location);
          show_testimonials_by_user_location(user_location);
          console.log(user_location);
        }
      }
      getRegion();
    }
  }
  /* announcement dynamic END */

  if (document.querySelector('.shopify-app-block #ppf-iframe')) {
    var iframe = document.querySelector('.shopify-app-block #ppf-iframe');
    iframe.onload = () => {
      iframe.contentDocument.body.style.height = "auto";
      iframe.contentDocument.body.style.backgroundColor = "#fff";
    }
  }

    if (document.querySelector('.warning-checkbox') && document.querySelector('.product-form__submit')) {
    if (!document.querySelector('.warning-checkbox').classList.contains('warning-checkbox--disabled')) {
      document.querySelector('.warning-checkbox__input').addEventListener('change', (event) => {
        if (event.currentTarget.checked) {
          document.querySelector('.product-form__submit').classList.remove('disabled');
        } else {
          document.querySelector('.product-form__submit').classList.add('disabled');
        }
      });
    }
  }
  function zoom(e){
    var zoomer = e.currentTarget;
    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
    x = offsetX/zoomer.offsetWidth*100;
    y = offsetY/zoomer.offsetHeight*100 + 100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }
  if (document.querySelector('#MainContent .product-media-container .product__modal-opener')) {
    if (window.innerWidth > 750) {
      var allMedia = document.querySelectorAll('#MainContent .product-media-container .product__modal-opener');
      var allMediaArr = Array.prototype.slice.call(allMedia);
      allMediaArr.forEach(function(item, index){
        if (item.querySelector('img')) {
          item.addEventListener('mousemove',function(e){
            item.querySelector('img').style.opacity = 0;
            item.querySelector('.product__media').style.background = 'transparent';
            var item_bg = item.querySelector('img').getAttribute('src');
            item.style.backgroundImage = 'url('+item_bg+')';
            zoom(e);
          });
          item.addEventListener('mouseleave',function(e){
            item.querySelector('img').style.opacity = 1;
            item.querySelector('.product__media').style.background = '';
            item.style.backgroundImage = 'none';
          });
        }
      });
    }
  }
});